/* Zenzena: klik kamkoliv na fotku v produktové galerii otevře fullscreen (PhotoSwipe).
   - Deleguje se na document, takže přežije překreslení galerie při změně varianty.
   - Využívá vestavěný event "lightbox:open" komponenty <product-gallery> (theme.js);
     index se počítá stejně jako v openLightBox (viditelné buňky typu image).
   - Aktivní jen uvnitř <product-gallery allow-zoom> (quick-buy zoom nemá → neaktivní). */
(function () {
  if (window.__zzGalleryLightbox) return;
  window.__zzGalleryLightbox = true;

  var start = null;
  document.addEventListener('pointerdown', function (e) {
    start = { x: e.clientX, y: e.clientY };
  }, { capture: true, passive: true });

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var gallery = e.target.closest('product-gallery[allow-zoom]');
    if (!gallery) return;

    // Kliky na tlačítka, odkazy a "view in space" nechat na původních handlerech.
    if (e.target.closest('a, button, open-lightbox-button, input, label, [data-shopify-xr]')) return;

    var cell = e.target.closest('.product-gallery__media');
    if (!cell || cell.getAttribute('data-media-type') !== 'image' || cell.hasAttribute('hidden')) return;

    var carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel || !carousel.contains(cell)) return;

    // Carousel layout s vlastním kurzorem naviguje klikem doleva/doprava – nepřebíjet.
    if (gallery.querySelector('.custom-cursor') && window.matchMedia('(pointer: fine)').matches) return;

    // Nezaměňovat swipe/drag za klik.
    if (start && (Math.abs(e.clientX - start.x) > 8 || Math.abs(e.clientY - start.y) > 8)) return;

    var cells = Array.prototype.filter.call(carousel.children, function (c) {
      return !c.hasAttribute('hidden') && c.getAttribute('data-media-type') === 'image';
    });
    var index = cells.indexOf(cell);
    if (index < 0) return;

    cell.dispatchEvent(new CustomEvent('lightbox:open', { bubbles: true, detail: { index: index } }));
  });
})();
